<div class="fav_wrap">
    <mat-dialog-content>
        <div class="header">
            <div class="rate-txt">Your changes won't be saved</div>
            <div>
                <img role="button" class="close" (click)="onClose($event, mode)" src="/assets/icons/Close.svg" alt="close"/>
            </div>
        </div>
        <div class="body">
            @if(mode == 'edit') {
                <p>If you discard, your prompt data, variable data and attachments won't be saved.</p>
            } @else if ( mode == 'user') {
                <p>If you leave this page, your variable data and attachments won't be saved.</p>
            } @else {
                <p>If you leave this page, your changes will not be saved. Are you sure you want to continue?</p>
            }
            
            @if(mode != 'search') {
                <div class="checkbox">
                    <mat-checkbox
                          class="modified-checkbox"
                          (change)="update($event)"
                        >
                          Don't show this message again
                    </mat-checkbox>
                </div>
            }
        </div>
        <div class="btn-div">
            <app-button class="button" [type]="'secondary'" [buttonType]="'button'" [buttonText]="modeText" (onClick)="goBack($event, mode)"></app-button>
            <app-button class="button" [type]="'primary'" [buttonType]="'button'" [buttonText]="'Cancel'" (onClick)="onClose($event, mode)"></app-button>
        </div>
    </mat-dialog-content>
</div>